module.exports = __webpack_public_path__ + "87b7e52d023169484d25df0e06e9ca78.pdf";